import React, { useEffect } from "react";

function SwagPage() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://shop.spreadshirt.com/shopfiles/shopclient/shopclient.nocache.js";
    script.async = true;
    document.body.appendChild(script);

    window.spread_shop_config = {
      shopName: "upself-merch",
      locale: "us_US",
      prefix: "https://shop.spreadshirt.com",
      baseId: "myShop"
    };
  }, []);

  return (
    <div className="container mt-5 pt-5">
      <h1 className="text-center">UPSelf Swag Store</h1>
      <div id="myShop" className="my-5 text-center">
        <p>Loading store...</p>
      </div>
    </div>
  );
}

export default SwagPage;
